<template>
    <div class="stockScoreDetailsTotal">
        <div class="ssdtTitle">{{ $t('subScore.finalScore') }}</div>
        <div class="ssdtValue">{{ normalizedScore }}</div>
    </div>
</template>

<script>
export default {
    props: ['score'],
    computed: {
        normalizedScore() {
            return this.score ? Math.abs(Math.round(this.score)) : 0;
        }
    }
}
</script>

<style lang="scss" scoped>
.stockScoreDetailsTotal {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: solid 1px #333;
    padding-top: 10px;
    .ssdtTitle {
        font-weight: bold;
    }
    .ssdtValue {
        font-weight: bold;
    }
}
</style>